import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Check } from 'lucide-react';
import { SignInButton } from '@clerk/clerk-react';

const Plan = ({ title, price, features, cta }) => (
  <Card className="border-slate-200">
    <CardContent className="p-6">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-bold text-lg">{title}</h3>
          <p className="text-sm text-slate-500">{price}</p>
        </div>
        <div>{cta}</div>
      </div>
      <ul className="mt-4 space-y-2 text-sm text-slate-600">
        {features.map((f, i) => (
          <li key={i} className="flex items-start gap-2">
            <Check className="w-4 h-4 text-green-600 mt-1" />
            <span>{f}</span>
          </li>
        ))}
      </ul>
    </CardContent>
  </Card>
);

export default function PricingTable({ isSignedIn }) {
  return (
    <div className="grid md:grid-cols-2 gap-6">
      <Plan
        title="Free"
        price="$0 / month"
        features={["Curated AI news", "Weekly digest", "Community updates"]}
        cta={<Button variant="outline">Current</Button>}
      />

      <Plan
        title="Pro"
        price="$7 / month"
        features={["Ad-free experience", "Exclusive deep-dives", "Early access to reports"]}
        cta={
          isSignedIn ? (
            <Button onClick={() => { window.location.href = '/suscription/billing'; }}>
              Subscribe
            </Button>
          ) : (
            <SignInButton>
              <Button>Sign in to subscribe</Button>
            </SignInButton>
          )
        }
      />
    </div>
  );
}
